import React from "react";
import { useNavigate, defer } from "react-router-dom";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import NotFoundPage from "../404/NotFound";
import PatientDashboard from "./PatientDashboard";
import AllPatients from "./AllPatients/AllPatients";

const HandleComponentSwitching = (props) => {
  let navigate = useNavigate();
  const componentLookup = {
    "": <AllPatients {...props} />,
    all: <AllPatients {...props} />,
    red: <AllPatients {...props} />,
    inactive: <AllPatients {...props} />,
    bhi: <AllPatients {...props} />,
    new: <AllPatients {...props} />,
    yellow: <AllPatients {...props} />,
    invited: <AllPatients {...props} />,
    single: <PatientDashboard {...props} />,
  };

  let currentPath = null;

  try {
    currentPath = window.location.pathname
      .split("patients")[1]
      .replaceAll("/", "");
  } catch (e) {}

  if (currentPath === "") {
    navigate("/patients/all/");
  } else if (isFinite(currentPath)) {
    //* Path like /patients/1234 where 1234 is the patient's ID would be true
    return componentLookup["single"];
  }
  return componentLookup[currentPath] || <NotFoundPage />;
};
export const patientDetailLoader = ({ request, params }) => {
  const id = params.patientid;
  return defer({
    //cal api to get patient
  });
};
const Patients = (props) => {
  return (
    <SidebarLayout {...props}>
      <HandleComponentSwitching {...props} />
    </SidebarLayout>
  );
};

export default Patients;
